import { Input } from "@/components/ui/input";
import { toast } from "react-hot-toast";

export function ExportTypeCheckboxes({ currentExport, data, setData }) {
  if (
    currentExport == "prt reporting" ||
    currentExport == "rrt reporting" ||
    currentExport == "part usage" ||
    currentExport == "asset" ||
    currentExport == "part repairable" ||
    currentExport == "part non repairable"
  ) {
    return (
      <div className="flex md:flex-row flex-col gap-[16px]">
        <h6 className="required min-w-[200px] font-bold">Export Type</h6>
        <div className="flex md:flex-row flex-col gap-[16px] w-full md:w-[450px]">
          <div className="flex items-center gap-[8px]">
            <Input
              className="accent-indigo-600 w-[20px] h-[20px]"
              name="export_type"
              id="detail"
              type="checkbox"
              checked={
                data.export_type && data.export_type == "detail" ? true : false
              }
              onChange={() => {
                if (
                  currentExport == "part usage" &&
                  !data.part_usage_ticket_type
                ) {
                  toast.error("Please select ticket type");
                  return;
                }
                setData({ ...data, export_type: "detail" });
              }}
            />
            <label htmlFor="detail">Detail</label>
          </div>
          <div className="flex items-center gap-[8px]">
            <Input
              className="accent-indigo-600 w-[20px] h-[20px]"
              name="export_type"
              id="summary"
              type="checkbox"
              checked={
                data.export_type && data.export_type == "summary" ? true : false
              }
              onChange={() => {
                if (
                  currentExport == "part usage" &&
                  !data.part_usage_ticket_type
                ) {
                  toast.error("Please select ticket type");
                  return;
                }
                setData({ ...data, export_type: "summary" });
              }}
            />
            <label htmlFor="summary">Summary</label>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
